/* eslint-disable no-unused-vars */
import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('produto', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    // eslint-disable-next-line no-unused-vars

    async findFood(_, idgrupo) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('produto/food'),
      ]);

      return data.data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
